import TiersContainer from './Tiers.container';
import Tiers from './Tiers';

export default TiersContainer(Tiers);
